import React from 'react';
import {TabbedOverviewPage, WhatItMeasuresSection} from '../components/OverviewSections.comp';

// Single page, no tab bar — per explicit instruction. AssessmentSuiteSection
// stays defined in OverviewSections.comp.jsx (not deleted) in case it's
// wanted back later, matching Network Dashboard's identical precedent.
const AboutAssessmentPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What Does the Child Online Safety (COS) Children Assessment Measure?',
                content: <WhatItMeasuresSection/>,
            },
        ]}
    />
);

export default AboutAssessmentPage;
